/* eslint-disable */

import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BellTwoTone, CloseOutlined } from "@ant-design/icons";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Search } from "react-feather";
import { all_routes } from "../../Router/all_routes";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  ADD_ACTIVITY,
  getApiBaseUrl,
} from "../../feature-module/AssetMgt/Config/Config";
import { Button, Popover, Spin } from "antd";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { UserContext } from "../../feature-module/AssetMgt/UserContext";
dayjs.extend(relativeTime);

// import Granulelogo from "./Assets/Granules_logo.png"
const Header = () => {
  const route = all_routes;
  const [toggle, SetToggle] = useState(false);
  const location = useLocation();
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [flagImage, setFlagImage] = useState("assets/img/flags/in.png");
  const [visible, setVisible] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [notificationsLoading, setNotificationsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [counts, setCounts] = useState({
    ReadCount: 0,
    UnreadCount: 0,
    TotalCount: 0,
  });
  // const { updateUserType } = useContext(UserContext);

  // const handleChange = (value) => {
  //   updateUserType(value);
  // };
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setFlagImage(
      lng === "en"
        ? "assets/img/flags/us-flag.svg"
        : lng === "fr"
          ? "assets/img/flags/fr.png"
          : lng === "es"
            ? "assets/img/flags/es.png"
            : "assets/img/flags/de.png",
    );
  };

  const roleId = parseInt(sessionStorage?.getItem("selectedRole"));

  if (roleId === null) {
    navigate("/");
  }

  const fetchNotifications = async () => {
    const user = JSON.parse(sessionStorage.getItem("user"));

    setNotificationsLoading(true);
    try {
      const response = await fetch(
        `${getApiBaseUrl()}/api/getnotificationsToUser?UserID=${user.UserID}`,
      );
      const result = await response.json();
      if (result?.Status) {
        setNotifications(result.ResultData || []);
      } else {
        setNotifications([]);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
      setNotifications([]);
    } finally {
      setNotificationsLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const ROLE_MAP = {
    2: "Admin",
    3: "Reviewer",
    4: "Supervisor",
    5: "Operator",
  };

  const userDataString = sessionStorage.getItem("user");
  const user = userDataString ? JSON.parse(userDataString) : null;

  useEffect(() => {
    if (location.pathname.includes("dashboard")) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [location.pathname]);

  const popoverTitle = (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <span>
        <h6>
          <i className="fa-regular fa-bell fa-lg me-2 fa-shake text-primary"></i>
          You Have New Notifications{" "}
        </h6>
      </span>
      <CloseOutlined
        onClick={() => setVisible(false)}
        style={{ cursor: "pointer", marginLeft: 8 }}
      />
    </div>
  );

  const handleContentClick = () => {
    setVisible(false);
    navigate("/assetmgt/notifications");
  };

  const popoverContent = (
    <div style={{ cursor: "pointer" }} onClick={handleContentClick}>
      <p>Click here to look at your Notifications</p>
    </div>
  );

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(
        document.fullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement ||
          document.msFullscreenElement,
      );
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("msfullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullscreenChange,
      );
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange,
      );
      document.removeEventListener(
        "msfullscreenchange",
        handleFullscreenChange,
      );
    };
  }, []);

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
    SetToggle((current) => !current);
  };

  const sidebarOverlay = () => {
    document?.querySelector(".main-wrapper")?.classList?.toggle("slide-nav");
    document?.querySelector(".sidebar-overlay")?.classList?.toggle("opened");
    document?.querySelector("html")?.classList?.toggle("menu-opened");
  };

  let pathname = location.pathname;

  const exclusionArray = [
    "/reactjs/template/dream-pos/index-three",
    "/reactjs/template/dream-pos/index-one",
  ];
  if (exclusionArray.indexOf(window.location.pathname) >= 0) {
    return "";
  }

  const { expandMenus } = useSelector(
    (state) => state.themeSetting.expandMenus,
  );
  const dataLayout = useSelector((state) => state.themeSetting.dataLayout);

  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };
  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };

  const handleLogout = async () => {
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));
      const userId = user?.UserID || 0;

      const requestData = {
        ActivityType: 2,
        PerformedBy: userId,
        PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
        Notes: "Logged out successfully",
        Location: "logout",
        IsSucces: 1,
      };

      const response = await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();

      if (data.status === true) {
        console.log("success");
        sessionStorage.clear();
        localStorage.clear();
        navigate("/signin");
      } else {
        alert("Logout activity failed to record. Please try again.");
        console.error("Logout API returned failure:", data);
      }
    } catch (error) {
      console.error("Error during logout:", error);
      alert("An error occurred. Please try again.");
    }
  };

  const fetchNotificationCount = async () => {
    try {
      const res = await fetch(
        `${getApiBaseUrl()}/api/getnotificationcount?UserID=${user.UserID}`,
      );
      const data = await res.json();

      if (data.Status && data.ResultData?.length > 0) {
        setCounts(data.ResultData[0]);
      }
    } catch (error) {
      console.error("Error fetching notification count:", error);
    }
  };

  // call API when component mounts
  useEffect(() => {
    fetchNotificationCount();
  }, []);

  const handleMarkAllAsRead = async () => {
    try {
      setLoading(true);

      const res = await fetch(
        `${getApiBaseUrl()}/api/markAllReadNoti?UserID=${user.UserID}&roleID=${
          user.Role
        }`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const data = await res.json();

      if (res.ok) {
        console.log(" Marked all as read:", data);
      } else {
        console.error(" Failed:", data);
      }
    } catch (err) {
      console.error(" Error:", err);
    } finally {
      setLoading(false);
      fetchNotifications();
      fetchNotificationCount();
    }
  };

  function timeAgo(dateString) {
    const created = new Date(dateString); // UTC from backend
    const now = new Date();

    const diffMs = now - created;
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffMinutes = Math.floor(diffMs / (1000 * 60));

    if (diffHours > 0) {
      return `${diffHours} hour${diffHours > 1 ? "s" : ""} ago`;
    } else if (diffMinutes > 0) {
      return `${diffMinutes} minute${diffMinutes > 1 ? "s" : ""} ago`;
    } else {
      return "just now";
    }
  }

  // Retrieve ActualUserType (original fixed type) and UserType (current selection)
  const actualUserTypeStr = sessionStorage.getItem("ActualUserType");
  const userTypeStr = sessionStorage.getItem("UserType");

  const actualUserType = actualUserTypeStr ? parseInt(actualUserTypeStr) : null;
  const currentUserType = userTypeStr ? parseInt(userTypeStr) : userTypeStr; // default to All

  const [selectedFilterType, setSelectedFilterType] = useState(currentUserType);

  // Sync with sessionStorage changes
  useEffect(() => {
    const stored = sessionStorage.getItem("UserType");
    if (stored !== null) {
      setSelectedFilterType(parseInt(stored));
    }
  }, []);

  const handleFilterTypeClick = (type) => {
    // Only allow change if ActualUserType is 0
    // if (actualUserType !== 3) return;

    setSelectedFilterType(type);
    sessionStorage.setItem("UserType", type.toString());

    // Optional: dispatch event so other components can react
    window.dispatchEvent(new Event("filtertypechange"));
  };

  const isButtonActive = (type) => selectedFilterType === type;

  const shouldShowFilterButtons = actualUserType === 3;

  // Determine which button(s) to show
  const getFilterButtons = () => {
    // 3 → show nothing
    if (actualUserType === 3) {
      return null;
    }

    // 1 → only Process
    if (actualUserType === 1) {
      return (
        <button type="button" className="btn btn-primary">
          Process
        </button>
      );
    }

    // 2 → only Non-Process
    if (actualUserType === 2) {
      return (
        <button type="button" className="btn btn-primary">
          Non-Process
        </button>
      );
    }

    // 0 → show all three
    if (actualUserType === 0) {
      return (
        <>
          <button
            type="button"
            className={`btn ${isButtonActive(0) ? "btn-primary" : "btn-outline-info"} me-2`}
            onClick={() => handleFilterTypeClick(0)}
          >
            All
          </button>

          <button
            type="button"
            className={`btn ${isButtonActive(1) ? "btn-primary" : "btn-outline-info"} me-2`}
            onClick={() => handleFilterTypeClick(1)}
          >
            Process
          </button>

          <button
            type="button"
            className={`btn ${isButtonActive(2) ? "btn-primary" : "btn-outline-info"}`}
            onClick={() => handleFilterTypeClick(2)}
          >
            Non-Process
          </button>
        </>
      );
    }

    return null;
  };

  return (
    <>
      <div className="header">
        {/* Logo */}
        <div className="main-header">
          {/* /Logo */}
          <Link
            id="mobile_btn"
            className="mobile_btn "
            to="#"
            onClick={sidebarOverlay}
          >
            {/* className="bar-icon" */}
            <span>
              <span />
              <span />
              <span />
            </span>
          </Link>

          {/* Header Menu */}
          <ul className="nav user-menu">
            {/* Search */}
            <li className="nav-item nav-searchinputs">
              <div className="top-nav-search">
                <Link to="#" className="responsive-search">
                  <Search />
                </Link>

                <h2 className="text-center  rounded ">
                  Filter Management System
                </h2>
              </div>
            </li>
            {/* /Search */}
            {/* Select Store */}
            <li className="nav-item dropdown has-arrow main-drop select-store-dropdown">
              <div className="dropdown-menu dropdown-menu-right">
                <Link to="#" className="dropdown-item">
                  <ImageWithBasePath
                    src="assets/img/store/store-01.png"
                    alt="Store Logo"
                    className="img-fluid"
                  />
                  Freshmart
                </Link>
                <Link to="#" className="dropdown-item">
                  <ImageWithBasePath
                    src="assets/img/store/store-02.png"
                    alt="Store Logo"
                    className="img-fluid"
                  />
                  Grocery Apex
                </Link>
                <Link to="#" className="dropdown-item">
                  <ImageWithBasePath
                    src="assets/img/store/store-03.png"
                    alt="Store Logo"
                    className="img-fluid"
                  />
                  Grocery Bevy
                </Link>
                <Link to="#" className="dropdown-item">
                  <ImageWithBasePath
                    src="assets/img/store/store-04.png"
                    alt="Store Logo"
                    className="img-fluid"
                  />
                  Grocery Eden
                </Link>
              </div>
            </li>
            {/* /Select Store */}

            {/* Flag */}
            <li className="nav-item dropdown has-arrow flag-nav nav-item-box">
              <div className="d-flex justify-content-center align-items-center flex-wrap gap-3 d-none text-center">
                <div className="d-flex align-items-center gap-2">
                  <i className="ti ti-user  text-primary"></i>
                  <span className="fw-bold">{user?.Name}</span>
                </div>

                <div className="d-flex align-items-center gap-2">
                  <i className="ti ti-id-badge  text-success"></i>
                  <span>{user?.RoleName}</span>
                </div>

                <div className="d-flex align-items-center gap-2">
                  <i className="ti ti-hash  text-secondary"></i>
                  <span>{user?.UserName}</span>
                </div>
              </div>

              <div className="dropdown-menu dropdown-menu-right">
                <Link
                  to="#"
                  className="dropdown-item active"
                  onClick={() => changeLanguage("en")}
                >
                  <ImageWithBasePath
                    src="assets/img/flags/english.svg"
                    alt="img"
                    height={16}
                  />
                  {t("English")}
                </Link>
                <Link
                  to="#"
                  className="dropdown-item"
                  onClick={() => changeLanguage("fr")}
                >
                  <ImageWithBasePath
                    src="assets/img/flags/arabic.svg"
                    alt="img"
                    height={16}
                  />{" "}
                  Arabic
                </Link>
              </div>
            </li>

            {/* NEW: Filter Type Buttons - Inserted Here */}
            <li className="nav-item nav-item-box d-flex align-items-center">
              {getFilterButtons()}
            </li>

            <li className="nav-item dropdown nav-item-box">
              <Popover
                placement="bottomRight"
                title={popoverTitle}
                content={popoverContent}
                open={visible}
              >
                <Link
                  to="#"
                  title="notifications"
                  className="dropdown-toggle nav-link"
                  data-bs-toggle="dropdown"
                >
                  <i
                    className={`fa-solid fa-bell fs-4 text-primary ${
                      counts?.UnreadCount > 0 ? "fa-shake" : ""
                    }`}
                  />
                  <span className="badge rounded-pill">
                    {counts?.UnreadCount}
                  </span>
                </Link>
              </Popover>

              <div className="dropdown-menu notifications shadow-lg">
                <div className="topnav-dropdown-header">
                  <h5 className="notification-title">Notifications</h5>
                  {counts?.UnreadCount > 1 && (
                    <div
                      onClick={!loading ? handleMarkAllAsRead : undefined}
                      className={`clear-noti cursor-pointer btn${
                        loading ? "opacity-50" : ""
                      }`}
                    >
                      {loading ? "Loading..." : "Mark all as read"}
                    </div>
                  )}
                </div>
                <div className="noti-content">
                  <ul className="notification-list">
                    {notificationsLoading ? (
                      <div className="text-center">
                        <Spin size="large" />
                      </div>
                    ) : counts?.UnreadCount === 0 ? (
                      <li className="notification-message text-muted text-center">
                        No new notifications
                      </li>
                    ) : (
                      notifications.map((noti) => (
                        <li className="notification-message" key={noti.id}>
                          {noti?.IsRead}
                          <div
                            className={`p-3 ${noti?.IsRead ? "d-none" : ""}`}
                          >
                            {noti?.isRead}
                            <div className="media d-flex">
                              <div className="flex-grow-1">
                                <p className="noti-details">
                                  <span className="noti-title">
                                    {noti.Title}
                                  </span>{" "}
                                  {noti.action}: <strong>{noti.Message}</strong>
                                </p>
                                <p className="noti-time">
                                  {timeAgo(noti.CreatedAt)}
                                </p>
                              </div>
                            </div>
                          </div>
                        </li>
                      ))
                    )}
                  </ul>
                </div>
                <div className="topnav-dropdown-footer d-flex align-items-center gap-3">
                  <Link to="#" className="btn btn-secondary btn-md w-100">
                    Cancel
                  </Link>
                  <Link
                    to={route.assetmgtNotifications}
                    className="btn btn-primary btn-md w-100"
                  >
                    View all
                  </Link>
                </div>
              </div>
            </li>

            <li className="nav-item dropdown has-arrow main-drop profile-nav">
              <Link
                to="#"
                className="nav-link userset"
                data-bs-toggle="dropdown"
              >
                <span className="user-info p-0">
                  <span className="user-letter">
                    <ImageWithBasePath
                      src="assets/img/profiles/avator1.jpg"
                      alt="Img"
                      className="img-fluid"
                    />
                  </span>
                </span>
              </Link>
              <div className="dropdown-menu menu-drop-user">
                <div className="profileset d-flex align-items-center">
                  <span className="user-img me-2">
                    <ImageWithBasePath
                      src="assets/img/profiles/avator1.jpg"
                      alt="Img"
                    />
                  </span>
                  <div>
                    {user ? (
                      <>
                        <h6 className="fw-medium">{user?.Name}</h6>
                        <p className="mb-0">
                          ID: {user?.UserName}
                          <br />
                          {user?.RoleName}
                        </p>
                      </>
                    ) : (
                      <p className="mb-0">No user data</p>
                    )}
                  </div>
                </div>
                <hr className="my-2" />
                <Link
                  className="dropdown-item logout pb-0"
                  to={route.signin}
                  onClick={handleLogout}
                >
                  <i className="ti ti-logout me-2" />
                  Logout
                </Link>
              </div>
            </li>
          </ul>

          {/* <div className="dropdown mobile-user-menu ">
            <Link
              to="#"
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-ellipsis-v" />
            </Link>
            <div className="dropdown-menu dropdown-menu-right">
              <Link className="dropdown-item" to="profile">
                My Profile
              </Link>
              <Link className="dropdown-item" to="generalsettings">
                Settings
              </Link>
              <Link className="dropdown-item" to="signin">
                Logout
              </Link>
            </div>
          </div> */}
          {/* /Mobile Menu */}
        </div>
      </div>
    </>
  );
};

export default Header;
